// Inicialización de Sentry para el frontend — se importa como primera línea de main.tsx.
// Errors-only (sin tracing/replay/logs) para rendir el free tier 5k y quedar GlitchTip-ready.
import * as Sentry from '@sentry/react'
import { installRequestIdFetch } from './lib/sentry/request-id'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  // Se activa solo si hay DSN. Sin DSN queda inerte (dev silencioso); para probar,
  // seteá VITE_SENTRY_DSN en el .env (los eventos se etiquetan environment=development).
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  tracesSampleRate: 0,
})

installRequestIdFetch()
